import { Button, Modal, notification } from "antd";
import PropTypes from "prop-types";
import axiosInstance from "../../../utils/axios";
import { useState } from "react";
import ModalModifications from "./ModalModifications";

const ModalReprise = (props) => {
  const { openModalReprise, setOpenModalReprise, dataReprise } = props;
  const [openModalModifications, setOpenModalModifications] = useState(false);
  const id_affaire = dataReprise?.affaire_id;
  const verifyDirectorDisponibility = () => {
    let cin = dataReprise?.establishment_director_data_cin_number;
    let passeport = dataReprise?.establishment_director_data_passeport;
    let nationality = dataReprise?.establishment_director_data_nationality;
    let identity = dataReprise?.establishment_director_data_identity;
    let payload = {
      role:
        identity === "مدير غير المستثمر"
          ? import.meta.env.VITE_APP_ID_ROLE_INVESTISSEUR
          : import.meta.env.VITE_APP_ID_ROLE_INVESTISSEUR_DIRCETEUR,
    };
    if (nationality === "تونسية") {
      payload.cin = cin;
    } else {
      payload.passport = passeport;
    }

    axiosInstance
      .post(
        `${import.meta.env.VITE_APP_GEOPROD_API}/admin/check_cin_role`,
        payload
      )
      .then((res) => {
        if (!res.data.cin_pass) {
          setOpenModalReprise(false);
          notification.success({
            message: "Succès",
            description:
              "La reprise de l'activité de l'établissement sera effectuée dans la date de reprise prévue.",
            duration: 0,
          });
          // axiosInstance
          //   .get(
          //     `${import.meta.env.VITE_APP_GEOPROD_API}/reprise_activite/${
          //       id_affaire
          //     }`,
          //     {
          //       headers: {
          //         Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
          //           ?.Acces_Token,
          //       },
          //     }
          //   )
          //   .then((response) => {

          //   })
          //   .catch((error) => {
          //     notification.error({
          //       message: "Erreur",
          //       description:
          //         "Une erreur s'est produite lors de la reprise de l'activité de l'établissement.",
          //       duration: 0,
          //     });
          //   });
        } else {
          setOpenModalReprise(false);
          notification.error({
            message: "Erreur",
            description:
              " Le directeur est désormais fonctionnel dans un autre EPF. Veuillez apporter une modification de type 2 pour pouvoir reprendre l'activité de l'établissement.",
            duration: 0,
          });
        }
      });
  };

  const openModalModiciations = () => {
    setOpenModalReprise(false);
    setOpenModalModifications(true);
  };


  return (
    <>
      <Modal
        title="Confirmation"
        open={openModalReprise}
        onCancel={() => setOpenModalReprise(false)}
        footer={[
          <Button key="oui" type="primary" onClick={openModalModiciations}>
            Oui
          </Button>,
          <Button key="non" onClick={verifyDirectorDisponibility}>
            Non
          </Button>,
        ]}
      >
        <p>
          Avez-vous apporté des modifications aux données de votre EPF lors de
          la fermeture provisoire ?
        </p>
      </Modal>
      <ModalModifications
        openModalModifications={openModalModifications}
        setOpenModalModifications={setOpenModalModifications}
        affaire_id={id_affaire}
      />
    </>
  );
};

ModalReprise.propTypes = {
  openModalReprise: PropTypes.object,
  setOpenModalReprise: PropTypes.func,
};

export default ModalReprise;
